import React from "react"
import PropTypes from "prop-types"

import {
  Grid, Row, Col, PageHeader, Table, Glyphicon, Pagination,
  Form, FormGroup, InputGroup, FormControl, Checkbox, 
  ButtonToolbar, Button,
} from "react-bootstrap"
import DatePicker from "react-bootstrap-date-picker"
// import {Table, Column, Cell} from "fixed-data-table-2"

import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { LinkContainer } from "react-router-bootstrap"

import { Map, List } from "immutable"
import objectAssign from "object-assign"

import moment from "moment-timezone"
import "moment/locale/id"

import numeral from "numeral"

import "whatwg-fetch"
import uuidV4 from "uuid"
import FileSaver from "file-saver"

import { CSVLink } from "react-csv"

import * as actionCreators from "../actions"
import { ButtonAdd, socket_protocol, socket_host, socket_port, api_path } from "./Common"

moment.tz.setDefault("Asia/Jakarta")

class Orders extends React.Component {
  static propTypes = {
    orders: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  state = {
    list_status: List(),
    list_final: List(),
    page: 1,
    rows_count: 10,
    filters: {},
    sorts: [{ column: "orderDate", direction: "DESC" }],
    selection: []
  }

  componentWillMount() {
    // this.getFilteredResult()
  }

  componentDidMount() {
    // socket.on("state", () => this.filterResult())
  }

  calculateQuickViews = (metadata, item) => {
    metadata.all++

    switch(item.get("orderStatus")) {
      case "BARU":
        metadata.baru++
        break
      case "BATAL":
        metadata.batal++
        break
      case "TERKIRIM":
        metadata.terkirim++
        break
      default:
    }

    if (item.get("salesStatus") === "YES")
      metadata.paymentYes++
    else
      metadata.paymentNo++

    if (item.get("purchaseStatus") === "YES")
      metadata.dealerYes++
    else
      metadata.dealerNo++

    return metadata
  }

  filterRecords = source => {
    let list = source
    let metadata = {
      all: 0, baru: 0, batal: 0, terkirim: 0,
      paymentYes: 0, paymentNo: 0, dealerYes: 0, dealerNo: 0,
      totalCost: 0, totalIncome: 0
    }

    if (this.state.filters) {
      const { startDate, endDate, dealerUuid, search } = this.state.filters
      list = source.filter(item => {
        // Filters
        if (startDate && item.get("orderDate") < startDate)
          return false
        if (endDate && item.get("orderDate") > endDate)
          return false
        if (dealerUuid && item.get("dealerUuid") !== dealerUuid)
          return false

        // Search filters
        if (search) {
          if (search.indexOf(",") !== -1) {
            const filterOrderNo = search.replace(" ","").split(",")
            if (filterOrderNo.indexOf(item.get("orderNo").toLowerCase()) === -1)
              return false
          } else {
            if (item.get("orderNo").toLowerCase().indexOf(search) === -1 &&
              this.props.dealers.getIn([item.get("dealerUuid"), "dealerName"]).indexOf(search) === -1 &&
              item.get("customerName").toLowerCase().indexOf(search) === -1)
              return false
          }
        }

        // Quickviews
        metadata = this.calculateQuickViews(metadata, item)

        // Filter status
        if (this.state.filters.orderStatus && item.get("orderStatus") !== this.state.filters.orderStatus)
          return false
        if (this.state.filters.purchaseStatus && (
          (this.state.filters.purchaseStatus === "YES" && item.get("purchaseStatus") !== "YES") ||
          (this.state.filters.purchaseStatus === "NO" && item.get("purchaseStatus") === "YES")
        ))
          return false
        if (this.state.filters.salesStatus && (
          (this.state.filters.salesStatus === "YES" && item.get("salesStatus") !== "YES") ||
          (this.state.filters.salesStatus === "NO" && item.get("salesStatus") === "YES")
        ))
          return false

        if (item.get("orderStatus") !== "BATAL" && item.get("salesAmount") !== 0) {
          metadata.totalIncome += item.get("salesAmount") + item.get("customerDeliveryFee")
          metadata.totalCost += item.get("purchaseAmount") + item.get("commissionTotal") + + item.get("dealerDeliveryFee")
        }
        
        return true
      })
    } else {
      list.forEach(item => {
        metadata = this.calculateQuickViews(metadata, item)
      })
    }

    if (this.state.sorts) {
      let { column, direction } = this.state.sorts[0]
      
      if (!column) {
        column = "orderDate"
        direction = "DESC"
      }

      list = list.sort((a, b) => {
        let a_column = a.get(column), b_column = b.get(column)
        
        switch(column) {
          case "dealerName":
            console.log("a_column:", a_column, ", b_column:", b_column)
            a_column = (this.props.dealers.getIn([a_column, "dealerName"])).toLowerCase()
            b_column = (this.props.dealers.getIn([b_column, "dealerName"])).toLowerCase()
            break

          // case "margin":
          //   a_column = a.get("salesAmount") - a.get("purchaseAmount")
          //   b_column = b.get("salesAmount") - b.get("purchaseAmount")
          //   break

          case "orderDate":
            break

          default:
            a_column = typeof a_column === 'string' ? a_column.toLowerCase() : a_column
            b_column = typeof b_column === 'string' ? b_column.toLowerCase() : b_column
            break
        }

        if ((direction === "DESC" && (a_column > b_column)) || (direction === "ASC" && (a_column < b_column)))
          return -1
        
        if ((direction === "DESC" && (a_column < b_column)) || (direction === "ASC" && (a_column > b_column)))
          return 1
        
        return 0
      })
    }

    return { list, metadata }
  }

  filterResult = () => {
    // let conditions = {}

    // // Refresh from Server
    // if (this.state.filters.startDate) conditions["orderDate"] = { $gte: this.state.filters.startDate }
    // if (this.state.filters.endDate) conditions["orderDate"] = { $lte: this.state.filters.endDate }
    // if (this.state.filters.dealerUuid) conditions["dealerUuid"] = this.state.filters.dealerUuid
    // this.props.actions.refreshOrders(conditions)
  }

  handleDelete = e => {
    e.preventDefault()
    
    const { id } = e.target
    if (window.confirm("Are you sure you want to delete this order?")) {
      this.props.actions.deleteOrder(id)
    }
  }

  handleSelectionChange = e => {
    const { value, checked } = e.target
    const idx = this.state.selection.indexOf(value)

    if (checked && idx === -1)
      this.setState((state, props) => {
        let selection = state.selection
        selection.push(value)
        return { selection }
      })
    else if (!checked && idx !== -1)
      this.setState((state, props) => {
        let selection = state.selection
        selection.splice(idx, 1)
        return { selection }
      })
  }

  handleCheckboxAllChange = e => {
    const checked = e.target.checked
    const selectors = document.getElementsByName("orderSelector")
    let selection = []

    for (let i = 0; i < selectors.length; i++) {
      selectors[i].checked = checked
      selection.push(selectors[i].id)
    }

    if (checked) {
      this.setState({ selection })
    } else {
      this.setState({ selection: [] })
    }
  }

  handleFilterStartDateChange = (value, formattedValue) => {
    let startDate = null
    if (value) startDate = moment(value).format("YYYY-MM-DD")
    this.setState((state, props) => ({
      filters: objectAssign(state.filters, { startDate })
    }), () => this.filterResult())
  }

  handleFilterEndDateChange = (value, formattedValue) => {
    let endDate = null
    if (value) endDate = moment(value).format("YYYY-MM-DD")
    this.setState((state, props) => ({
      filters: objectAssign(state.filters, { endDate })
    }), () => this.filterResult())
  }

  handleFilterDealerChange = e => {
    const { value } = e.target
    this.setState((state, props) => ({
      filters: objectAssign(state.filters, { dealerUuid: value })
    }), () => this.filterResult())
  }

  handleFilterSearchChange = e => {
    let { value } = e.target
    if (value.length === 0)
      value = null
    else
      value = value.toLowerCase()

    this.setState((state, props) => ({
      filters: objectAssign(state.filters, { search: value })
    }))
  }

  handleStatusFilter = e => {
    let { name, value } = e.target

    this.setState((state, props) => {
      let { filters } = state
      delete filters.orderStatus
      delete filters.purchaseStatus
      delete filters.salesStatus

      if (value.length > 0)
        filters[name] = value      

      return { filters } 
    })
  }

  handleRowsChange = e => {
    const rows = e.target.value
    this.setState({ rows })
  }

  handlePageSelect = page => {
    this.setState({ page })
  }

  handlePaymentReceived = e => {
    if (window.confirm("Are you sure you want to change Payment Received status?")) {
      const { id, value } = e.target
      const orderStatus = value === "YES" ? "TERKIRIM" : "BARU"
      this.props.actions.updateOrder(id, { salesStatus: value, orderStatus } )
    }
  }

  handleDealerPaid = e => {
    if (window.confirm("Are you sure you want to change Dealer Paid status?")) {
      const { id, value } = e.target
      this.props.actions.updateOrder(id, { purchaseStatus: value } )
    }
  }

  handleSortChange = e => {
    const { id } = e.target
    let { column, direction } = this.state.sorts[0]

    console.log("id:", id)

    if (id !== column) {
      column = id
      direction = "ASC"
    } else if (direction === "ASC")
      direction = "DESC"
    else
      direction = "ASC"
    
    this.setState({ sorts: [{ column, direction }]})
  }

  handleUpdateStatus = e => {
    if (this.state.selection.length === 0)
      return

    if (window.confirm("Are you sure you want to update the status?")) {
      const { value } = e.target
      
      if (value === "BATAL") {
        this.props.actions.updateOrder(
          this.state.selection,
          { orderStatus: value, purchaseStatus: "NO", salesStatus: "NO" }
        )
      } else if (value === "TERKIRIM") {
        this.props.actions.updateOrder(this.state.selection, { orderStatus: value })
      } else if (value.substr(0, 3) === "PAY") {
        if (value.substr(-3) === "YES")
          this.props.actions.updateOrder(this.state.selection, { salesStatus: "YES" })
        else
          this.props.actions.updateOrder(this.state.selection, { salesStatus: "NO" })
      } else if (value.substr(0, 3) === "DEA") {
        if (value.substr(-3) === "YES")
          this.props.actions.updateOrder(this.state.selection, { purchaseStatus: "YES" })
        else
          this.props.actions.updateOrder(this.state.selection, { purchaseStatus: "NO" })
      }
  
      // Clear up selections
      e.target.value = ""
    }
  }

  handleDownload = e => {
    e.preventDefault()

    const { value } = e.target
    const { selection } = this.state

    let url = socket_protocol + "//" + socket_host + ":" + socket_port + api_path + "/zip?" +
      "type=" + value + 
      selection.reduce((result, id) => result + "&orderNo[]=" + this.props.orders.getIn([id, "orderNo"]), "")

    // Fetch url then save
    fetch(url).then(res => res.blob())
    .then(blob => FileSaver.saveAs(blob, uuidV4() + ".zip"))
  }

  createCsv = list => {
    let csv = [], uuid

    list.forEach(item => {
      item.get("details").valueSeq().forEach(detail => {
        if (item.get("uuid") !== uuid)
          csv.push([
            item.get("orderNo"),
            this.props.dealers.getIn([item.get("dealerUuid"), "dealerName"]),
            item.get("customerName"),
            item.get("customerPhone1"),
            item.get("customerAddress"),
            moment(item.get("orderDate")).format("LL"),
            item.get("orderStatus"),
            item.get("salesStatus"),
            item.get("purchaseStatus"),
            detail.get("productName"),
            detail.get("orderQuantity"),
            detail.get("purchasePrice"),
            detail.get("orderQuantity") * detail.get("purchasePrice"),
            detail.get("commission"),
            detail.get("salesPrice"),
            detail.get("orderQuantity") * detail.get("salesPrice"),
            item.get("dealerDeliveryFee"),
            item.get("customerDeliveryFee")
          ])
        else
          csv.push([
            item.get("orderNo"),
            this.props.dealers.getIn([item.get("dealerUuid"), "dealerName"]),
            item.get("customerName"),
            item.get("customerPhone1"),
            item.get("customerAddress"),
            moment(item.get("orderDate")).format("LL"),
            item.get("orderStatus"),
            item.get("salesStatus"),
            item.get("purchaseStatus"),
            detail.get("productName"),
            detail.get("orderQuantity"),
            detail.get("purchasePrice"),
            detail.get("orderQuantity") * detail.get("purchasePrice"),
            detail.get("commission"),
            detail.get("salesPrice"),
            detail.get("orderQuantity") * detail.get("salesPrice"),
            0,
            0
          ])
        uuid = item.get("uuid")
      })
    })

    return csv
  }

  render() {

    const { list, metadata } = this.filterRecords(this.props.orders.valueSeq(0))

    let list_show
    if (list.toJS().length < (this.state.page * this.state.rows_count))
      list_show = list.slice((this.state.page - 1) * this.state.rows_count)
    else
      list_show = list.slice((this.state.page - 1) * this.state.rows_count, this.state.page * this.state.rows_count)

    const headers_csv = [
      "Order No",
      "Dealer",
      "Nama Customer",
      "No. Telepon",
      "Alamat",
      "Tanggal Pesanan",
      "Status",
      "Payment Received",
      "Dealer Paid",
      "Barang",
      "Qty",
      "Harga Modal",
      "Total Modal",
      "Komisi",
      "Harga Jual",
      "Total Jual",
      "Ongkir Supplier",
      "Ongkir Customer"
    ]

    return (
      <Grid>
        <PageHeader>
          Order 
          <span className="pull-right">
            {/* <Button bsSize="small" onClick={() => this.props.actions.refreshOrders()}>
              <Glyphicon glyph="refresh" />
            </Button> */}
            <ButtonAdd to="/order_new" />
          </span>
        </PageHeader>
        
        <Form inline style={{ marginTop: "10px" }}>
          Filter:&nbsp;
          <DatePicker bsSize="small"
            placeholder="Start Date"
            value={this.state.filters.startDate}
            dateFormat="DD-MM-YYYY"
            onChange={this.handleFilterStartDateChange}
            onClear={this.handleFilterStartDateChange} />&nbsp;
          <DatePicker bsSize="small"
            placeholder="End Date"
            value={this.state.filters.endDate}
            dateFormat="DD-MM-YYYY"
            onChange={this.handleFilterEndDateChange}
            onClear={this.handleFilterEndDateChange} />&nbsp;
          <FormControl bsSize="small"
            componentClass="select"
            onChange={this.handleFilterDealerChange}>
            <option value="">(All)</option>
            { this.props.dealers.valueSeq().map(d => (
              <option key={d.get("uuid")} value={d.get("uuid")}>{d.get("dealerName")}</option>
            ))}
          </FormControl>
          <span className="pull-right text-right">
            <h4><u>Total Margin:</u></h4>
            <h4>
              {numeral(metadata.totalIncome).format("0,0")} - {numeral(metadata.totalCost).format("0,0")} =&nbsp;
              <span className={"text-" + (metadata.totalIncome - metadata.totalCost < 0 ? "danger" : "success")}>
                {numeral(metadata.totalIncome - metadata.totalCost).format("0,0")}
              </span>
            </h4>
          </span>
        </Form>
        
        <Row style={{ marginTop: "10px" }}>
          <Col xs={12} sm={8}>
            <u>Quick View:</u>
            <ButtonToolbar>
              <Button bsStyle="link" name="orderStatus" value="" onClick={this.handleStatusFilter}>
                All ({ metadata.all })
              </Button>
              <Button bsStyle="link" name="orderStatus" value="BARU" onClick={this.handleStatusFilter}>
                BARU ({ metadata.baru }) {this.state.filters.orderStatus === "BARU" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
              <Button bsStyle="link" name="orderStatus" value="BATAL" onClick={this.handleStatusFilter}>
                BATAL ({ metadata.batal }) {this.state.filters.orderStatus === "BATAL" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
              <Button bsStyle="link" name="orderStatus" value="TERKIRIM" onClick={this.handleStatusFilter}>
                TERKIRIM ({ metadata.terkirim }) {this.state.filters.orderStatus === "TERKIRIM" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
            </ButtonToolbar>
            <ButtonToolbar>
              <Button bsStyle="link" name="salesStatus" value="YES" onClick={this.handleStatusFilter}>
                Payment Received ({ metadata.paymentYes }) {this.state.filters.salesStatus === "YES" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
              <Button bsStyle="link" name="salesStatus" value="NO" onClick={this.handleStatusFilter}>
                No Payment ({ metadata.paymentNo }) {this.state.filters.salesStatus === "NO" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
              <Button bsStyle="link" name="purchaseStatus" value="YES" onClick={this.handleStatusFilter}>
                Dealer Paid ({ metadata.dealerYes }) {this.state.filters.purchaseStatus === "YES" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
              <Button bsStyle="link" name="purchaseStatus" value="NO" onClick={this.handleStatusFilter}>
                Unpaid Dealer ({ metadata.dealerNo }) {this.state.filters.purchaseStatus === "NO" ? <Glyphicon bsSize="small" glyph="ok" /> : null}
              </Button>
            </ButtonToolbar>
          </Col>

          <Col xs={12} sm={4} className="text-right">
            <CSVLink className="btn btn-default" data={this.createCsv(list)} headers={headers_csv}>
              Download CSV
            </CSVLink>
          </Col>
        </Row>
        
        <div style={{ marginTop: "20px" }}>
          <Form inline>
            Show&nbsp;<FormControl bsSize="small" componentClass="select">
            {[10, 20, 30, 50, 100].map(i =>
              <option key={i} value={i}>{i}</option>
            )}
            </FormControl>&nbsp;rows
            <span className="pull-right">
              <FormGroup bsSize="small">
                <InputGroup>
                  <FormControl name="searchFilter" placeholder="Search" onChange={this.handleFilterSearchChange} />
                  <InputGroup.Addon><Glyphicon glyph="search" /></InputGroup.Addon>
                </InputGroup>
              </FormGroup>
            </span>
          </Form>
          <Table responsive fill striped>
            <thead>
              <tr>
                <th className="text-center">
                  {/* <Checkbox bsSize="small" name="checkboxAll" onChange={this.handleCheckboxAllChange} /> */}
                </th>
                <th className="text-center" id="orderNo" onClick={this.handleSortChange}>
                  Order No.&nbsp;
                  {
                    this.state.sorts[0].column === "orderNo" ?
                    <Glyphicon id="orderNo" glyph={"sort-by-attributes" + (this.state.sorts[0].direction === "ASC" ? "" : "-alt")} />
                    : null
                  }
                </th>
                <th className="text-center" id="dealerName" onClick={this.handleSortChange}>
                  Dealer&nbsp;
                  {
                    this.state.sorts[0].column === "dealerName" ?
                    <Glyphicon id="dealerName" glyph={"sort-by-attributes" + (this.state.sorts[0].direction === "ASC" ? "" : "-alt")} />
                    : null
                  }
                </th>
                <th className="text-center" id="customerName" onClick={this.handleSortChange}>
                  Nama Customer&nbsp;
                  {
                    this.state.sorts[0].column === "customerName" ?
                    <Glyphicon id="customerName" glyph={"sort-by-attributes" + (this.state.sorts[0].direction === "ASC" ? "" : "-alt")} />
                    : null
                  }
                </th>
                <th className="text-center">
                  No. Telp.
                </th>
                <th className="text-center">
                  Alamat
                </th>
                <th className="text-center" id="orderDate" onClick={this.handleSortChange}>
                  Tanggal Pesan&nbsp;
                  {
                    this.state.sorts[0].column === "orderDate" ?
                    <Glyphicon id="orderDate" glyph={"sort-by-attributes" + (this.state.sorts[0].direction === "ASC" ? "" : "-alt")} />
                    : null
                  }
                </th>
                <th className="text-center">
                  Status
                </th>
                <th className="text-center" id="margin" onClick={this.handleSortChange}>
                  Margin&nbsp;
                  {
                    this.state.sorts[0].column === "margin" ?
                    <Glyphicon id="margin" glyph={"sort-by-attributes" + (this.state.sorts[0].direction === "ASC" ? "" : "-alt")} />
                    : null
                  }
                </th>
                <th className="text-center">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {
                list_show.map(o => (
                  <tr key={o.get("uuid")}>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                      <Checkbox bsSize="small" name="orderSelector" value={o.get("uuid")} onChange={this.handleSelectionChange} /> 
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {o.get("orderNo")}
                      <Button className="pull-right" bsSize="xsmall" bsStyle="danger" id={o.get("uuid")} onClick={this.handleDelete}>
                        <Glyphicon glyph="trash" id={o.get("uuid")} />
                      </Button>
                    </td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>{this.props.dealers.getIn([o.get("dealerUuid"), "dealerName"])}</td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>{o.get("customerName")}</td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>{o.get("customerPhone1")}</td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                      {
                        o.get("customerAddress") && o.get("customerAddress").length > 30 ?
                        o.get("customerAddress").substr(0, 27) + "..." :
                        o.get("customerAddress")
                      }
                    </td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                      {moment(o.get("orderDate")).format("LL")}
                    </td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                      {o.get("orderStatus")}
                      {o.get("orderStatus") === "BATAL" ? null :
                        <div>
                          <Button bsSize="xsmall"
                            bsStyle={o.get("salesStatus") === "YES" ? "success" : "default"}
                            id={o.get("uuid")}
                            value={o.get("salesStatus") === "YES" ? "NO" : "YES"}
                            onClick={this.handlePaymentReceived}>
                            Payment Recv'd.
                          </Button><br />
                          <Button bsSize="xsmall"
                            bsStyle={o.get("purchaseStatus") === "YES" ? "success" : "default"}
                            id={o.get("uuid")}
                            value={o.get("purchaseStatus") === "YES" ? "NO" : "YES"}
                            onClick={this.handleDealerPaid}>
                            Dealer Paid
                          </Button>
                        </div>
                      }
                    </td>
                    <td className={`text-right text-${o.get("margin") < 0 ? "danger" : "success"}`}
                      style={{ verticalAlign: "middle" }}>
                      {numeral(o.get("margin")).format("0,0")}
                    </td>
                    <td className="text-center" style={{ verticalAlign: "middle" }}>
                      <LinkContainer to={`/order/${o.get("uuid")}`}>
                        <Button bsSize="xsmall">Detail</Button>
                      </LinkContainer>
                    </td>
                  </tr>
                ))
              }
            </tbody>
            <tfoot>
              <tr>
                <td className="text-right" colSpan="100">
                  <Pagination prev next first last ellipsis boundaryLinks
                    items={Math.floor(list.toJS().length / this.state.rows_count) + 1}
                    maxButtons={5}
                    activePage={this.state.page}
                    onSelect={this.handlePageSelect} />
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Form inline>
            <FormControl bsSize="small"
              componentClass="select"
              onChange={this.handleUpdateStatus}>
              <option value="">Update Status</option>
              <option value="BATAL">Update to BATAL</option>
              <option value="TERKIRIM">Update to TERKIRIM</option>
              <option value="PAYMENT_YES">Update to Payment Received - YES</option>
              <option value="PAYMENT_NO">Update to Payment Received - NO</option>
              <option value="DEALER_YES">Update to Dealer Paid - YES</option>
              <option value="DEALER_NO">Update to Dealer Paid - NO</option>
            </FormControl>
            <FormControl bsSize="small"
              componentClass="select"
              onChange={this.handleDownload}>
              <option value="">Download</option>
              <option value="po">Download PO</option>
              <option value="faktur">Download Faktur</option>
            </FormControl>
          </Form>
        </div>

      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  dealers: state.get("dealers") || Map(),
  orders: state.get("orders") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Orders)



// WEBPACK FOOTER //
// ./src/components/Orders.js